import "./i18n";
import React from "react";
import { Toaster } from 'sonner'
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import App from "./App";
import store from "./app/store";
import MuiThemeProvider from "./theme/MuiThemeProvider";

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <MuiThemeProvider>
        <Toaster richColors />
        <App />
      </MuiThemeProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);
